import { combineEpics } from 'redux-observable';
import helpEpics from '@ane/help-app-module/lib/module/epics';
import experimentEpics from '@ane/experiment-app-module/lib/module/epics';
import appExperimentSearchEpics from '@ane/experiment-search-app-module/lib/module/epics';
import progressionsModuleEpics from '@ane/progressions-app-module/lib/module/epics';
import coreEpics from '@ane/exp-data/lib/services/epics/CoreEpics';
import trafficFiltersEpics from '@ane/trafficFilter/lib/module/epics';
import analysisTemplateEpics from '@ane/analysis-template/lib/module/epics';
import tenantPageEpics from '@ane/tenant/lib/module/epics';
import flightEpics from '@ane/flight-app-module/lib/module/epics';
import UserDetailsEpics from '@ane/exp-data/lib/userDetails/UserDetailsEpic';
import GlobalConfigEpic from '@ane/exp-data/lib/globalConfig/GlobalConfigEpic';
import srmDebugModuleEpic from '@ane/srm-debug-app-module/lib/module/epics';
import ExtensionsModuleEpic from '@ane/extensions/lib/module/epics';
/**
 * GAR and Analysis epics
 */
import garModuleEpic from '@ane/summary-app-module/lib/module/epics';
import dataSourceManagementModuleEpic from '@ane/datasource-management/lib/module/epics';
import budgetModuleEpic from '@ane/budget/lib/module/epics';
import emergencyShutdownEpic from '@ane/emergency-shutdown/lib/module/epics';
import { gateEpics } from '@ane/expalert/lib/module/epics';
import managementGroupSelectorEpics from '@ane/exp-ux/lib/components/ManagementGroupSelector/ManagementGroupSelector.epics';
import computeManagementSystemModuleEpic from '@ane/compute-management-system/lib/module/epics';
import { rootEpic as hypothesisEpic } from '@ane/hypothesis-app-module/lib/module/epics';
import workspaceSettingsEpics from '@ane/workspace-settings/lib/module/epics';

import unifiedStudioEpics from '@ane/unified-studio/lib/module/epics';
import rootWorkspaceEpics from '@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.epics';
import userAccessEpics from '@ane/exp-ux/lib/components/GetUserAccess/UserAccess.epics';
import notifiactionModuleEpic from '@ane/notification/lib/module/epics';
import assignmentUnitRootEpic from '@ane/assignment-unit-app-module/lib/module/epics';
import { rootEpic as metricsAuthoringEpics } from '@ane/metrics-authoring/lib/module/epics';
import { rootEpic as assignmentDetailsRootEpic } from '@ane/exp-data/lib/assignmentDetailsV2';
import LoadSubscriberEpics from '@ane/exp-ux/lib/components/Subscribers/LoadSubscribers.epics';
import SetSubscriberEpics from '@ane/exp-ux/lib/components/Subscribers/SetSubscribers.epics';
import LoadSubscriberEpicsV2 from '@ane/exp-ux/lib/components/Subscribers/LoadSubscribersV2.epics';
import SetSubscriberEpicsV2 from '@ane/exp-ux/lib/components/Subscribers/SetSubscribersV2.epics';
import { rootEpic as rootApiEpic } from '@ane/exp-data/lib/redux/api';

// TODO: combine the epics from the (routeUserSpecMap) 'app-modules' interface

export const epics = () =>
  combineEpics(
    coreEpics,
    appExperimentSearchEpics,
    helpEpics,
    progressionsModuleEpics,
    experimentEpics,
    analysisTemplateEpics,
    tenantPageEpics,
    flightEpics,
    trafficFiltersEpics,
    UserDetailsEpics,
    GlobalConfigEpic,
    srmDebugModuleEpic,
    ExtensionsModuleEpic,
    garModuleEpic,
    dataSourceManagementModuleEpic,
    budgetModuleEpic,
    managementGroupSelectorEpics,
    emergencyShutdownEpic,
    gateEpics,
    computeManagementSystemModuleEpic,
    hypothesisEpic,
    rootWorkspaceEpics,
    unifiedStudioEpics,
    userAccessEpics,
    notifiactionModuleEpic,
    assignmentUnitRootEpic,
    metricsAuthoringEpics,
    workspaceSettingsEpics,
    assignmentDetailsRootEpic,
    LoadSubscriberEpics,
    SetSubscriberEpics,
    LoadSubscriberEpicsV2,
    SetSubscriberEpicsV2,
    rootApiEpic,
  );
